import React from 'react';
import * as cls from './start-saving-now.module.css';
import { Typography } from '../../../ui/components/typography';
import { Section } from '../../../ui/components/section';
import { IMG_PATH } from '../../../constants';

export const StartSavingNow = ({ url }) => {
  return (
    <Section backgroundContrast>
      <Typography as="h1" tag="h2">
        Start Saving Now
      </Typography>

      <div className={cls.wrapper}>
        <Typography>
          <em>See where your electricity goes in real time.</em>
        </Typography>
        <Typography>
          <em>
            Get appliance-level insights, standby alerts and practical tips to
            cut waste.
          </em>
        </Typography>
        <a href={url} rel="noopener noreferrer" target="_blank">
          <img
            alt="Order Now on Amazon"
            src={`${IMG_PATH}/amazon-shop/order-now-on-amazon.png`}
          />
        </a>
      </div>
    </Section>
  );
};
